import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemService } from '../services/system.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: HttpClient, private system: SystemService) { }

  getModules(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/common/modules");
  }

  getAppModules(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/common/app-modules");
  }

  getLanguages(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/common/languages");
  }

  getCurrencies(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/common/currencies");
  }
}
